import { History } from 'history';
import * as queryString from 'query-string';

import { getTagKeyValue } from '@sbu/hooks.tags';

import {
  deserializeQuery,
  serializeQuery,
} from 'shared/components/internal/Filter/serializer';

export const onTagClick = (history: History, tag: string) => {
  const newTagFilter = {
    prop: 'tag',
    operator: 'equals',
    value: tag,
    negated: false,
  };

  const qs = queryString.parse(history.location.search);
  const query = qs.q ? (qs.q as string) : undefined;
  const filters = deserializeQuery(query, undefined);
  const { key, value } = getTagKeyValue(tag);

  // Add a new tag filter if there is no duplicate.
  const newFilters = query?.includes(`tag:"${key ? key + ':' + value : value}"`)
    ? filters
    : [...filters, newTagFilter];

  history.push({
    ...history.location,
    search: queryString.stringify({
      ...qs,
      q: serializeQuery(newFilters),
      offset: 0,
    }),
  });
};
